import { render } from "./SwapView.vue?vue&type=template&id=5e948882"
import script from "./SwapView.vue?vue&type=script&lang=js"
export * from "./SwapView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__